import React, { useState, useEffect } from "react";
import { Button, Card, Container, Row, Col, Form, Image } from "react-bootstrap";
import "./Login.css";
import { apiUrl } from "../commons/inFormTypes";
import { useNavigate, NavLink, useSearchParams } from "react-router-dom";
import FooterLogin from "../components/FooterLogin";
import HeaderLogin from "../components/HeaderLogin";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FormData from "form-data";
import { useUserSession } from "../components/user-context";
import { Avatar } from "antd";
import { swing } from "react-animations";
import Radium, { StyleRoot } from "radium";
import LoaderBtn from "../components/LoaderBtn";
import CustomInput from "../components/CustomInput";
import { handleEnter } from "../components/CommonFunections";
import useViewport from "../custom-hooks/useViewport ";
import thumbnail from "../assets/img/thumbnail.png"
import falg from "../assets/img/flag.png"
import Loaders from "../components/Loaders";



function Login() {
  const [load, setLoad] = useState(true);
  const [seenFile, setSeenFile] = useState({})
  const [code, setCode] = useState("");
  const [codeMeli, setCodeMeli] = useState("");
  const [formIsValid, setFormIsValid] = useState("2");
  const [mobile, setMobile] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [error, setError] = useState("");
  const [errorRegister, setErrorRegister] = useState("");
  const [token, setToken] = useState(true);
  const [errorName, setErrorName] = useState("");
  const [errorFamily, setErrorFamily] = useState("");
  const [errorCodeMeli, setErrorCodeMeli] = useState("");
  const [snip, setSnip] = useState(false);
  const [snipSso, setSnipSso] = useState(false);
  const axios = require("axios");
  const navigate = useNavigate();
  const { logIn } = useUserSession();
  const { width } = useViewport(); //custom hook for responsive layouts
  const [searchParams, setSearchParams] = useSearchParams();
  const promptToken = searchParams.get('Usertoken');
  const promptCode = searchParams.get('code');



  const styles = {
    swing: {
      animation: "x 4s",
      animationName: Radium.keyframes(swing, "swing"),
    },
  };


  // const handleLoaded = _ => {
  //   window.grecaptcha.ready(_ => {
  //     window.grecaptcha
  //       .execute("6Lc6QcsgAAAAAI9Vo5ECahePZoHCSkn4Rxk849Ua", { action: "register" })
  //       .then(token => {

  //       })
  //   })
  // }

  useEffect(() => {
    // Add reCaptcha
    const script = document.createElement("script")
    script.src = "https://www.google.com/recaptcha/api.js?render=6Lc6QcsgAAAAAI9Vo5ECahePZoHCSkn4Rxk849Ua"
    // script.addEventListener("load", handleLoaded)
    document.body.appendChild(script)

    
      window.addEventListener("load", () => {  
        if (promptToken !== null) {
        setLoad(false);
      window.grecaptcha.ready(_ => {
        window.grecaptcha
          .execute("6Lc6QcsgAAAAAI9Vo5ECahePZoHCSkn4Rxk849Ua", { action: "register" })
          .then(gToken => {
            axios
              .post(apiUrl + "sso/mycity-verify", {
                headers: {
                  'Access-Control-Allow-Origin': "*",
                  Accept: "application/json",
                },
                token: promptToken,
                "g-recaptcha-response": gToken,
              })
              .then((res) => {
                setLoad(true);
                if (res.data.success) {
                  localStorage.setItem("user_namefamily", res.data.result.full_name);
                  localStorage.setItem("user_token", res.data.result.token);
                  navigate("/admin/dashboard");
                } else {
                  toast.error(res.data.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                  });
                  navigate("/");
                }
              })
              .catch(function (error) {
                setSnip(true);
                if (error.response) {
                  console.log("data", error.response.data);
                  toast.error(error.response.data.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                  });
                }
              });
          });
      });
      }else if(promptCode !== null){  
        setLoad(false);    
        window.grecaptcha.ready(_ => {
         
        window.grecaptcha
          .execute("6Lc6QcsgAAAAAI9Vo5ECahePZoHCSkn4Rxk849Ua", { action: "register" })
          .then(gToken => {
            axios
              .post(apiUrl+"sso/get-token", {
                headers: {
                  'Access-Control-Allow-Origin': "*",
                  Accept: "application/json",
                },
                code: promptCode,
                "g-recaptcha-response": gToken,
              })
              .then((res) => {
                setLoad(true);
                if (res.data.success) {
                  localStorage.setItem("user_namefamily", res.data.result.full_name);
                  localStorage.setItem("user_token", res.data.result.token);
                  navigate("/admin/dashboard");
                } else {
                  toast.error(res.data.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                  });
                  navigate("/");
                }
              })
              .catch(function (error) {
                setSnip(true);
                if (error.response) {
                  console.log("data", error.response.data);
                  toast.error(error.response.data.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                  });
                }
              });
          });
      });
    }
    else{

    }
    });
    

    //title and logo
    axios({
      method: "get",
      url: apiUrl + "settings",
      headers: {},
    }).then((res) => {
      console.log(res)
      setSeenFile(res.data.data)
      console.log("result" + res.data.data.title)
    });
  }, [])




  const loginHandler = (e) => {

    e.preventDefault();
    if (
      mobile.length < 11 ||
      mobile === ""
    ) {
      setErrorRegister("لطفا شماره موبایل صحیح را وارد کنید");
      return false;
    } else {

      setSnip(true);
      window.grecaptcha.ready(_ => {
        window.grecaptcha
          .execute("6Lc6QcsgAAAAAI9Vo5ECahePZoHCSkn4Rxk849Ua", { action: "register" })
          .then(gToken => {
            axios
              .post(apiUrl + "customer-login", {
                headers: {
                  'Access-Control-Allow-Origin': "*",
                  Accept: "application/json",
                  Authorization: "Bearer " + token,
                },
                mobile: mobile,
                "g-recaptcha-response": gToken,
              })
              .then((res) => {
                setSnip(false);
                if (res.data.success) {
                  setToken(res.data.result.token);
                  setFormIsValid("3");
                } else {
                  toast.error(res.data.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                  });
                }
              })
              .catch(function (error) {
                setSnip(false);
                if (error.response) {
                  console.log("data", error.response.data);
                  toast.error(error.response.data.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                  });
                }
              });
          });
      });
    }
  };

  const backHandler = () => {
    setFormIsValid("2");
  }

  const submitHandler = (e) => {
    e.preventDefault();
    if (code.length > 6 || code === "" || code.length < 6) {
      setError("لطفا کد صحیح را وارد کنید");
      return false;
    } else {
      const axios = require("axios");
      setSnip(true);


      window.grecaptcha.ready(_ => {
        window.grecaptcha
          .execute("6Lc6QcsgAAAAAI9Vo5ECahePZoHCSkn4Rxk849Ua", { action: "register" })
          .then(gToken => {
            axios
              .post(apiUrl + "customer-login", {
                headers: {
                  'Access-Control-Allow-Origin': "*",
                  Accept: "application/json",
                  Authorization: "Bearer " + token,
                },
                password: code,
                mobile: mobile,
                token: token,
                "g-recaptcha-response": gToken,
              })
              .then((res) => {
                setSnip(false);
                if (res.data.success) {
                  if (res.data.result.isNewCustomer) {
                    setToken(res.data.result.token);
                    setFormIsValid("1");
                  } else {
                    logIn(res.data.result.full_name);
                    localStorage.setItem(
                      "user_namefamily",
                      res.data.result.full_name
                    );
                    localStorage.setItem("user_token", res.data.result.token);
                    navigate("/admin/dashboard");
                  }
                } else {
                  toast.error(res.data.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                  });
                }
              })
              .catch(function (error) {
                setSnip(false);
                if (error.response) {
                  console.log("data", error.response.data);
                  toast.error(error.response.data.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                  });
                }
              });
          });
      });
    }
  };

  const registerHandler = (e) => {
    e.preventDefault();
    if (firstName === "") {
      setErrorName("لطفا نام خود را وارد کنید");
      return;
    } else {
      setErrorName("");
    }
    if (lastName === "") {
      setErrorFamily("لطفا نام خانوادگی خورد را وارد کنید");
      return;
    } else {
      setErrorFamily("");
    }
    if (codeMeli === "" || codeMeli.length < 10 || codeMeli.length > 10) {
      setErrorCodeMeli("لطفا کد ملی درست را وارد کنید");
      return;
    } else {
      setErrorCodeMeli("");
      const axios = require("axios");
      var data = new FormData();
      data.append("firstname", firstName);
      data.append("lastname", lastName);
      data.append("mobile", mobile);
      data.append("address", "1");
      data.append("nationalcode", codeMeli);

      // setLoad(false);
      setSnip(true);
      axios({
        method: "post",
        url: apiUrl + "profile",
        headers: {
          'Access-Control-Allow-Origin': "*",
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
        data: data,
      })
        .then((res) => {
          setSnip(false);
          if (res.data.success) {
            localStorage.setItem("user_namefamily", res.data.result.full_name);
            localStorage.setItem("user_token", token);
            logIn(localStorage.getItem("user_namefamily"));
            navigate("/admin/dashboard");
          } else {
            toast.error(res.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        })
        .catch(function (error) {
          setSnip(false);
          if (error.response) {
            console.log("data", error.response.data);
            toast.error(error.response.data.message, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 3000,
            });
          }
        });
    }
  };

  //enter for input insted of click button submitHandler function
  const keyPress = (e, val) => {
    if (e.keyCode === 13) {
      switch (val) {
        case 0:
          registerHandler(e)
          break;

        case 1:
          submitHandler(e);
          break;

        case 2:
          loginHandler(e);
          break;

        default:
          break;
      }
    }
  }


  const myStyle = {
    backgroundImage: `url(${seenFile.right_image})`,
    height: '100vh',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    position: 'relative',
    opacity: '1',
    backgroundPosition: 'center'
  };

  const testHandler = () => {
    setSnipSso(true);
    axios({
      method: "get",
      url: "https://desk.myamol.ir/api/sso/get-url",
      headers: {
        'Access-Control-Allow-Origin': "*",
        Accept: "application/json",
      }
    })
      .then((res) => {
        setSnipSso(false);
        if (res.data.success) {
            window.location.replace(`${res.data.url}`)
            localStorage.setItem("urlSso",res.data.url)
           
        } else {
        
        }
      })
      .catch(function (error) {
        setSnipSso(false);
        if (error.response) {
          console.log("data", error.response.data);
          toast.error(error.response.data.message, {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 3000,
          });
        }
      });
   }
 

  return (

    <div>
      {/* <HeaderLogin /> */}
      <div className="container-fluid rgc-test">
        <Image src={falg} className="rgc-image d-none d-lg-block" />
        <Row className="align-items-center">

          <Col xs={12} lg={6} style={myStyle} className="rgc-test-img">
            <div className="rgc-layer">
              <div className="rgc-test-content">
                <Image src={seenFile.right_logo} alt="thumbnail" className="img-fluid" />
                <div className="rgc-test-txt m-0 m-lg-3">
                  <p>
                    {seenFile.right_text}
                  </p>
                </div>
              </div>
            </div>
          </Col>
          

          <Col xs={10} lg={3} className="rgc-log m-auto" >

            <div className="">
              <div className="text-center">
                <div className="rgc-logo">
                  <Image src={seenFile.logo} />
                  <span>{seenFile.title}</span>
                </div>

                <div className={formIsValid === "1" ? "d-block" : "d-none"}>
                  <Form>
                    <CustomInput
                      icon={"fas fa-user-alt"}
                      label={"نام"}
                      type={"text"}
                      value={firstName}
                      placeholder={"نام"}
                      onChange={(event) => setFirstName(event.target.value)}
                      onKeyDown1={handleEnter}
                    />

                    <CustomInput
                      icon={"fas fa-user-circle"}
                      label={"نام خانوادگی"}
                      type={"text"}
                      value={lastName}
                      placeholder={"نام خانوادگی"}
                      onChange={(event) => setLastName(event.target.value)}
                      onKeyDown1={handleEnter}
                    />

                    <CustomInput
                      icon={"fa fa-id-card"}
                      label={"کد ملی"}
                      type={"number"}
                      value={codeMeli}
                      placeholder={"کد ملی"}
                      onChange={(event) => setCodeMeli(event.target.value)}
                      onKeyDown1={handleEnter}
                    />

                    <CustomInput
                      icon={"fas fa-mobile-alt"}
                      label={"شماره همراه"}
                      type={"number"}
                      value={mobile}
                      placeholder={"شماره همراه"}
                      onChange={(event) => setMobile(event.target.value)}
                      onKeyDown1={(event) => keyPress(event, 0)}
                    />

                  </Form>

                  <Button
                    type="submit"
                    className="btn-fill m-1 rgc-btn"
                    onClick={registerHandler}
                    variant="btn btn-primary"
                  >
                    <LoaderBtn loads={snip} />
                    <span>ورود به صفحه اصلی</span>
                  </Button>

                </div>

                <div className={formIsValid === "2" ? "d-block" : "d-none"}>
                  <CustomInput
                    icon={"fas fa-mobile-alt"}
                    label={"شماره همراه"}
                    type={width > 820 ? "text" : "number"}
                    value={mobile}
                    placeholder={"شماره همراه"}
                    onChange={(event) => setMobile(event.target.value)}
                    onKeyDown1={(event) => keyPress(event, 2)}
                  />


                  <div
                    className="g-recaptcha"
                    data-sitekey="6Lc6QcsgAAAAAI9Vo5ECahePZoHCSkn4Rxk849Ua"
                    data-size="invisible"
                  ></div>

                  <Button
                    type="submit"
                    className="btn-fill m-1 rgc-btn"
                    onClick={loginHandler}
                    variant="btn btn-primary"
                  >
                    <LoaderBtn loads={snip} />
                    <span> درخواست رمز یکبارمصرف</span>
                  </Button>

                  {/* <Button
                    type="submit"
                    className="btn-fill my-2 rgc-btn rgc-btn-black"
                    onClick={testHandler}
                    variant="btn btn-primary"
                  >
                    
                    <span>ورود از پنجره واحد خدمات وزارت کشور</span>
                    <LoaderBtn loads={snipSso} />
                  </Button> */}
                </div>

                <div className={formIsValid === "3" ? "d-block" : "d-none"}>
                  <span>لطفا کد شش رقمی را وارد نمایید</span>
                  <CustomInput
                    icon={"fa fa-key"}
                    label={"ورود کد"}
                    type={width > 820 ? "text" : "number"}
                    value={code}
                    placeholder={"ورود کد"}
                    onChange={(event) => setCode(event.target.value)}
                    onKeyDown1={(event) => keyPress(event, 1)}
                  />

                  <Button
                    type="submit"
                    className="btn-fill m-1 rgc-btn"
                    onClick={submitHandler}
                    variant="btn btn-primary"
                  >
                    <LoaderBtn loads={snip} />
                    <span> ورود/ثبت نام</span>
                  </Button>

                  <Button
                    type="submit"
                    className="btn-fill m-1 rgc-btn"
                    // className="btn-fill m-1 rgc-back-btn"
                    onClick={backHandler}
                    variant="btn btn-danger"
                  >
                    <i className='fas fa-share rgc-back-icon'></i>
                    <span>تغییر شماره همراه</span>
                  </Button>

                </div>

                <hr className="my-4" />
                <StyleRoot>
                  <div className="test" style={styles.swing}>
                    <div className="rgc-social d-flex flex-row align-items-center justify-content-center">
                      <a href="">
                        <i
                          className="far fa-question-circle"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <a href="">
                        <i className="fa fa-globe" aria-hidden="true"></i>
                      </a>
                      <a href="">
                        <i
                          className="fas fa-book-reader"
                          aria-hidden="true"
                        ></i>
                      </a>
                      <hr className="my-4" />
                    </div>
                  </div>
                </StyleRoot>
                {/* 
                    <hr className="my-2" />
                    <NavLink to="/appguide" aria-current="page">
                      {" "}
                      راهنمای اپلیکیشن
                    </NavLink> */}
              </div>
            </div>

          </Col>
        </Row>
      </div>
      {/* <FooterLogin /> */}

      <div className="rgc-toast">
        <ToastContainer autoClose={3000} />
      </div>
      <Loaders loads={load} />
    </div>
  );
}
export default Login;

//Focus on the Next Field
// export const handleEnter = (event) => {
//   if (event.key.toLowerCase() === "enter") {
//     if (event.key() === "enter") {
//     const form = event.target.form;
//     const index = [...form].indexOf(event.target);
//     form.elements[index + 1].focus();
//     event.preventDefault();
//   }
// }
